import Model from './model.js'

export default {
	ReadAsMaster: function (params) {
		if(params.action === 'LOCATION') {
			params.data.query = 'Location/Master/'; 
		}
		if(params.action === 'SITE') {
			params.data.query = 'Location/Sites-Master/'; 
		}
    if(params.action === 'MAINTENANCE') {
      params.data.query = 'Maintenance/Service/Master/'; 
    }
		Model.ReadAsMaster(params)
	},
	ReadMasterReservation: function (params) {
		Model.ReadMasterReservation(params)
	},
	ReadTimeLine: function (params) {
		if(params.action === 'Next') {
			params.data.url = params.self.state.NextPage;
		}
		if(params.self.props.Cluster === 'all') {
			params.data.cluster = 'all'; 
		}
		if(params.self.props.Cluster === 'idle') {
			params.data.cluster = 'idle'; 
		}
		if(params.self.props.Cluster === 'unavailable') {
			params.data.cluster = 'unavailable'; 
		}
		Model.Read(params)
	},
	ReadMaintenaceByAsset: function(params){
		if(params.action === 'Next') {
			params.data.url = params.self.state.NextPage;
		}
		Model.ReadMaintenanceByAsset(params);
	},
	ReadTracking: function (params){
		if(params.action === 'Next') {
			params.data.url = params.self.state.NextPage;
		}
		Model.ReadTracking(params);
	},
	ReadComment: function (params) {
		if(params.action === 'Next') {
			params.data.url = params.self.state.NextPage;
		}
		Model.ReadComments(params)
	},
	RegisterComment: function (params) {
		Model.RegisterComment(params);
	},

	RegisterBooking: function (params) {
		Model.RegisterBooking(params);
	},

	RegisterNote: function(params) {
		Model.RegisterNote(params);
	},
  RegisterRequestMaintenance: function(params) {
    Model.RequestMaintenance(params);
  }
}




// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/presenter.js